export const wiki = {
  wiki: 'Вікі',
  homeH1: 'Вікі зі скінів CS2',
  homeSubtitle: 'Усі скіни CS2: зношеність, рідкісність, кейси та колекції',
  categoriesTitle: 'Категорії',
  featuredTitle: 'Скіни докладно',
  allWeaponsTitle: 'Уся зброя',
  aboutWiki: 'Про вікі',
  readMore: 'Читати далі',
  showAll: 'Показати всі {{count}}',
  floatScaleLabel: 'Шкала флоту від 0 до 1 та знос для кожного діапазону',
  searchPlaceholder: 'Знайди скін, зброю або кейс',
  searchPlaceholderShort: 'Скін, зброя або кейс',
  searchSubmit: 'Шукати',
  searchClear: 'Очистити пошук',
  searchH1: 'Пошук по вікі',
  searchResultsFor: 'Результати за запитом «{{q}}»',
  searchEmptyTitle: 'Нічого не знайдено',
  searchEmptyText: 'Перевір написання або спробуй назву англійською.',
  searchEmptyTextLatin: 'Перевір написання або скороти запит.',
  searchOpenCatalog: 'Відкрити каталог',
  searchErrorTitle: 'Пошук не завантажився',
  searchErrorText: 'Перевір з’єднання та спробуй ще раз.',
  searchShortQuery: 'Введи щонайменше два символи.',
  retry: 'Спробувати ще раз',
  suggestEmpty: 'Збігів немає',
  suggestAll: 'Показати всі результати',
  typeSkin: 'Скін',
  typeWeapon: 'Зброя',
  typeContainer: 'Кейс',
  typeCollection: 'Колекція',
  catPistols: 'Пістолети',
  catRifles: 'Гвинтівки',
  catSmgs: 'ПК',
  catHeavy: 'Важка зброя',
  catKnives: 'Ножі',
  catGloves: 'Рукавиці',
  catEquipment: 'Спорядження',
  weaponsTitle: 'Зброя',
  modelsTitle: 'Моделі',
  selectionsTitle: 'Добірки',
  guidesTitle: 'Гайди',
  containersTitle: 'Нові кейси',
  allSkins: 'Усі скіни',
  allGuides: 'Усі гайди',
  allSelections: 'Усі добірки',
  allCases: 'Усі кейси',
  allCollections: 'Усі колекції',
  skinsOne: '{{count}} скін',
  skinsFew: '{{count}} скіни',
  skinsMany: '{{count}} скінів',
  knivesOne: '{{count}} ніж',
  knivesFew: '{{count}} ножі',
  knivesMany: '{{count}} ножів',
  glovesOne: '{{count}} пара рукавиць',
  glovesFew: '{{count}} пари рукавиць',
  glovesMany: '{{count}} пар рукавиць',
  rareItemsOne: '{{count}} предмет',
  rareItemsFew: '{{count}} предмети',
  rareItemsMany: '{{count}} предметів',
  skinsPlusRare: '{{skins}} + {{rare}}',
  catalogH1: 'Скіни CS2',
  catalogCategoryH1: 'Скіни CS2: {{category}}',
  filtersTitle: 'Фільтри',
  filterWeapon: 'Зброя',
  filterRarity: 'Рідкісність',
  filterCollection: 'Колекція',
  filterCase: 'Кейс',
  filterExterior: 'Знос',
  filterStatTrak: 'Є StatTrak™',
  filterSouvenir: 'Є Сувенір',
  anyWeapon: 'Будь-яка зброя',
  anyRarity: 'Будь-яка рідкісність',
  anyCollection: 'Будь-яка колекція',
  anyCase: 'Будь-який кейс',
  removeFilter: 'Прибрати фільтр «{{name}}»',
  sortLabel: 'Сортування',
  sortRarity: 'За рідкісністю',
  sortName: 'За назвою',
  sortRelease: 'Спочатку нові',
  sortPrice: 'За ціною',
  applyFilters: 'Показати',
  resetFilters: 'Скинути фільтри',
  resetShort: 'Скинути',
  closeFilters: 'Закрити фільтри',
  catalogEmptyTitle: 'Немає скінів за цими фільтрами',
  catalogEmptyText: 'Прибери кілька фільтрів або скинь усі.',
  prevPage: 'Назад',
  nextPage: 'Далі',
  pageOf: 'Сторінка {{page}} з {{count}}',
  foundCount: 'Знайдено: {{count}}',
  foundCountMasculine: 'Знайдено: {{count}}',
  priceFrom: 'від {{price}}',
  weaponAllFilters: 'Усі фільтри в каталозі',
  breadcrumbs: 'Навігаційний ланцюжок',
  exteriorFn: 'Щойно з фабрики',
  exteriorMw: 'Майже без подряпин',
  exteriorFt: 'Після бойових випробувань',
  exteriorWw: 'З численними подряпинами',
  exteriorBs: 'Понівечено в боях',
  kindNormal: 'Звичайний',
  kindStatTrak: 'StatTrak™',
  kindSouvenir: 'Сувенір',
  vanillaFinish: 'Vanilla',
  phasesTitle: 'Фази',
  statsTitle: 'Характеристики',
  statWeapon: 'Зброя',
  statFinish: 'Візерунок',
  statRarity: 'Рідкісність',
  statFloat: 'Діапазон флоту',
  statExteriors: 'Знос',
  statKinds: 'Версії',
  statCollections: 'Колекція',
  statContainers: 'Кейси',
  statRelease: 'Рік виходу',
  rareItem: 'рідкісний предмет',
  rareDropNote: 'Випадає як рідкісний предмет ★',
  pricesTitle: 'Ціни Steam',
  pricesHint: 'Ціна на Торговельному майданчику Steam у доларах США.',
  priceAsOf: 'Оновлено {{date}}.',
  noPrice: 'Актуальних даних немає',
  noPriceMarked: 'Актуальних даних для позначених версій немає',
  gameDescriptionTitle: 'Опис у грі',
  faqTitle: 'FAQ',
  similarTitle: 'Схожі скіни',
  shotTitle: 'Є на SHOT',
  shotHint: 'Цей скін є в складі кейсів SHOT.',
  dropsTitle: 'Нещодавні дропи',
  dropsHint: 'Хто його отримав на SHOT і де.',
  dropsCase: 'Кейс «{{name}}»',
  dropsCaseBattle: 'Кейс-батл',
  dropsUpgrade: 'Upgrade',
  dropsContract: 'Контракт',
  dropsRushMid: 'Rush Mid',
  dropsRoulette: 'Російська рулетка',
  timeJustNow: 'щойно',
  timeMinutesAgo: '{{count}} хв тому',
  timeHoursAgo: '{{count}} год тому',
  timeDaysAgo: '{{count}} дн тому',
  englishName: 'Назва англійською',
  caseReleased: 'Вийшов у {{year}} році',
  rareTitle: 'Рідкісні предмети',
  compositionTitle: 'Скіни всередині',
  rareHintKnives: 'Ножі випадають із цього кейса як окремий рідкісний предмет.',
  rareHintGloves: 'Рукавиці випадають із цього кейса як окремий рідкісний предмет.',
  rareHintKnivesAndGloves: 'Ножі та рукавиці випадають із цього кейса як окремий рідкісний предмет.',
  rareKnives: 'ножі',
  rareGloves: 'рукавиці',
  rareKnivesAndGloves: 'ножі та рукавиці',
  caseCollectionTitle: 'Колекція кейса',
  collectionCasesTitle: 'Кейси з цією колекцією',
  collectionReleased: 'Вийшла у {{year}} році',
  tocTitle: 'Зміст',
  reviewedOn: 'Перевірено {{date}}',
  reviewedBy: 'Перевірила команда SHOT · {{date}}',
  shortAnswer: 'Коротка відповідь',
  guidesH1: 'Гайди зі скінів CS2',
  selectionsH1: 'Добірки скінів CS2',
  casesH1: 'Кейси CS2',
  collectionsH1: 'Колекції CS2',
  weaponSkinsH1: 'Скіни {{weapon}}',
};

export const wikiItem = {
  typeSticker: 'Наліпка',
  typeAgent: 'Агент',
  typeCharm: 'Брелок',
  typeMusicKit: 'Музичний альбом',
  typePatch: 'Нашивка',
  typeGraffiti: 'Графіті',
  typePin: 'Значок',
  sectionStickers: 'Наліпки',
  sectionAgents: 'Агенти',
  sectionCharms: 'Брелоки',
  sectionMusicKits: 'Музичні альбоми',
  sectionPatches: 'Нашивки',
  sectionGraffiti: 'Графіті',
  sectionPins: 'Значки',
  kindCase: 'Кейс',
  kindStickerCapsule: 'Капсула наліпок',
  kindAutographCapsule: 'Капсула автографів',
  kindSouvenirPackage: 'Сувенірний набір',
  kindMusicKitBox: 'Скриня музичних альбомів',
  kindPatchCapsule: 'Набір нашивок',
  kindPinsCapsule: 'Капсула значків',
  kindGraffitiBox: 'Скриня графіті',
  tabAll: 'Усі',
  tabCases: 'Кейси',
  tabStickerCapsules: 'Капсули наліпок',
  tabAutographCapsules: 'Капсули автографів',
  tabSouvenirPackages: 'Сувенірні набори',
  tabMusicKitBoxes: 'Скрині музичних альбомів',
  tabPatchCapsules: 'Набори нашивок',
  tabPinsCapsules: 'Капсули значків',
  tabGraffitiBoxes: 'Скрині графіті',
  kindsNavLabel: 'Типи контейнерів',
  containersH1: 'Кейси та капсули CS2',
  h1StickerCapsules: 'Капсули наліпок CS2',
  h1AutographCapsules: 'Капсули автографів CS2',
  h1SouvenirPackages: 'Сувенірні набори CS2',
  h1MusicKitBoxes: 'Скрині музичних альбомів CS2',
  h1PatchCapsules: 'Набори нашивок CS2',
  h1PinsCapsules: 'Капсули значків CS2',
  h1GraffitiBoxes: 'Скрині графіті CS2',
  stickersOne: '{{count}} наліпка',
  stickersFew: '{{count}} наліпки',
  stickersMany: '{{count}} наліпок',
  musicKitsOne: '{{count}} музичний альбом',
  musicKitsFew: '{{count}} музичні альбоми',
  musicKitsMany: '{{count}} музичних альбомів',
  patchesOne: '{{count}} нашивка',
  patchesFew: '{{count}} нашивки',
  patchesMany: '{{count}} нашивок',
  pinsOne: '{{count}} значок',
  pinsFew: '{{count}} значки',
  pinsMany: '{{count}} значків',
  graffitiOne: '{{count}} графіті',
  graffitiFew: '{{count}} графіті',
  graffitiMany: '{{count}} графіті',
  colorsOne: '{{count}} колір',
  colorsFew: '{{count}} кольори',
  colorsMany: '{{count}} кольорів',
  inGameSince: 'У грі з {{year}} року',
  contentsTitle: 'Що всередині',
  variantsTitle: 'Варіанти',
  groupSticker: 'Наліпка',
  groupSlab: 'У слебі',
  effectPaper: 'Папір',
  effectHolo: 'Голо',
  effectFoil: 'Фольга',
  effectGold: 'Золото',
  effectGlitter: 'Блискітки',
  effectLenticular: 'Лентикулярна',
  effectEmbroidered: 'Вишита',
  stickerAutograph: 'Автограф',
  stickerTeam: 'Команда',
  stickerEvent: 'Турнір',
  stickerOther: 'Інше',
  sideT: 'Терористи',
  sideCt: 'Спецпризначенці',
  statType: 'Тип',
  statStickerKind: 'Тип наліпки',
  statTournament: 'Турнір',
  statTeam: 'Команда',
  statPlayer: 'Гравець',
  statEffects: 'Ефекти',
  statSlab: 'У слебі',
  statSide: 'Сторона',
  statArtist: 'Автор',
  statStatTrak: 'StatTrak™',
  statColors: 'Кольори',
  valueYes: 'Є',
  valueNo: 'Немає',
  whereTitle: 'Де отримати',
  whereCollection: 'Колекція',
  whereStickerPack: 'Набір наліпок',
  shotHintItem: 'Цей предмет випадає з цих кейсів SHOT.',
  souvenirPackagesRow: 'Сувенірні набори',
  moreCount: 'ще {{count}}',
  typeHighlight: 'Брелок із яскравим моментом',
  typePass: 'Перепустка',
  typeKey: 'Ключ',
  sectionHighlights: 'Брелоки з яскравими моментами',
  sectionPasses: 'Перепустки',
  sectionKeys: 'Ключі',
  kindOther: 'Набір',
  tabOther: 'Інше',
  h1Other: 'Інші набори CS2',
  itemsOne: '{{count}} предмет',
  itemsFew: '{{count}} предмети',
  itemsMany: '{{count}} предметів',
  statEvent: 'Турнір',
  statStage: 'Стадія',
  statMap: 'Карта',
  statTeams: 'Матч',
  statVideo: 'Відео',
  watchVideo: 'Дивитися момент',
  statOpens: 'Відкриває',
  listH1Stickers: 'Наліпки CS2',
  listH1Agents: 'Агенти CS2',
  listH1Charms: 'Брелоки CS2',
  listH1MusicKits: 'Музичні альбоми CS2',
  listH1Patches: 'Нашивки CS2',
  listH1Graffiti: 'Графіті CS2',
  listH1Highlights: 'Брелоки з яскравими моментами CS2',
  listH1Pins: 'Значки CS2',
  listH1Passes: 'Перепустки CS2',
  listH1Keys: 'Ключі до кейсів CS2',
  listCount: '{{count}} у грі',
  typeCollectible: 'Колекційний предмет',
  sectionCollectibles: 'Монети, медалі та трофеї',
  listH1Collectibles: 'Монети, медалі та трофеї CS2',
  collectibleCoin: 'Монета',
  collectibleTrophy: 'Трофей',
  collectibleMedal: 'Медаль',
  versionNumber: 'Версія {{n}}',
  allItemsTitle: 'Усі предмети',
  sectionContainers: 'Кейси та капсули',
};
